module.exports = __webpack_public_path__ + "img/icon1.24e15587.svg";